
import { Vue, Options } from "vue-class-component";
import router from "@/app/ui/router";
import {
  CargoV2Data,
  CargoV2DetailStt,
  BagOrSttDetail
} from "@/domain/entities/CargoV2";
import Print from "./modules/print.vue";
import { CargoData, CargoDetailStt } from "@/domain/entities/Cargo";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import { CargoController } from "../../controllers/CargoController";
import { NGenController } from "../../controllers/NGenController";
import { CargoV2Controller } from "../../controllers/CargoV2Controller";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import {
  ellipsisString,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import WidgetDownloadCargo from "@/app/ui/views/cargo/component/widget-download-cargo.vue";
import { DownloadAWBRequest } from "@/data/payload/api/CargoV2ApiRequest";
import { FlagsPermissionCargoV2 } from "@/feature-flags/flags-permission-cargo-v2";

@Options({
  components: {
    Print,
    WidgetDownloadCargo
  }
})
export default class CargoV2Detail extends Vue {
  leavePageConfirmation = false;
  answerLeavingPage = false;
  nextPath = "";
  selectedItem: CargoV2Data | null = null;
  isRtcDg = false;
  isRtcQuarantine = false;

  mounted() {
    this.refs = this.$refs;
    this.tabSelected = this.tabs[0];
    this.fetchDetailData();
  }

  get permissionDownloadAwbReceiptSync() {
    return FlagsPermissionCargoV2.permission_cargo_v2_download_awb_receipt_sync_enable.isEnabled();
  }

  get tabs() {
    return [
      {
        name: "info",
        title: this.$t("cargo.v2.detail.tab.info"),
        dataTestid: "cargo-v2-detail-tab-info"
      },
      {
        name: "history",
        title: this.$t("cargo.v2.detail.tab.history"),
        dataTestid: "cargo-v2-detail-tab-history"
      }
    ];
  }

  get cargoNo(): any {
    return decodeURIComponent(String(this.$route.params?.id));
  }

  get rcNo(): any {
    return decodeURIComponent(String(this.$route?.query?.rc_no));
  }

  get detailData() {
    if (this.$route?.query?.rc_no) {
      return CargoController.cargoDetailData;
    } else {
      return CargoV2Controller.cargoDetailData;
    }
  }

  get ableToEdit() {
    return FlagsPermissionCargo.permission_cargo_detail_edit.isEnabled();
  }

  private _syncFormBagOrSttFromDetail() {
    if (!this.$route?.query?.rc_no) {
      const source = (this.detailData.detailStt || []) as CargoV2DetailStt[];
      const mapped = source.map(
        (item) =>
          new BagOrSttDetail({
            bagNo: item.baggingNumber,
            bagVendorNo: item.baggingVendorNumber,
            sttNo: item.sttNumber,
            sttNoElexys: item.sttElexysNumber || "",
            sttTotalPiece: item.sttTotalPiece || item.totalPieces || 0,
            grossWeight: item.grossWeight || item.sttGrossWeight || 0,
            volumeWeight: item.volumeWeight || item.sttVolumeWeight || 0,
            chargeableWeight:
              item.bagCustomChargeableWeight ||
              item.bagTotalChargeableWeight ||
              0,
            productType: item.productType || item.sttProductType || "",
            commodityId: 0,
            commodityName: item.sttCommodityName || "",
            commodityCode:
              item.commodityGroupCode || item.sttCommodityName || "",
            commodityGroupCode: item.commodityGroupCode || "",
            commodityGroupName: item.commodityGroupName || "",
            commodityGroupIsDg: !!item.commodityGroupIsDg,
            destinationCityCode:
              item.destination || item.destinationCityCode || "",
            destinationCityName: item.destinationCityName || "",
            destinationDistrictCode: "",
            destinationDistrictName: "",
            shcCode: item.shcCode || "",
            shcDescription: item.shcName || "",
            sttPieces: item.sttPieces || [],
            isDangerousGoods: !!item.isDangerousGoods,
            bagData: item.bagData,
            sttChargeableWeight: item.chargeableWeight || 0,
            bagPhotoProof: item.bagPhotoProof || [],
            baggingNumber: item.baggingNumber || "",
            baggingVendorNumber: item.baggingVendorNumber || "",
            baggingVendorNo: item.baggingVendorNo || "",
            isDisputeBagging: !!item.isDisputeBagging,
            isQuarantine: !!item.isQuarantine
          })
      );
      CargoV2Controller.onGenerateGroupDataTable(mapped as any);
    } else {
      const source = (this.detailData.detailStt || []) as CargoDetailStt[];
      const mapped = source.map((item) => {
        return new BagOrSttDetail({
          bagNo: item.baggingNumber,
          bagVendorNo: item.baggingVendorNumber,
          sttNo: item.sttNumber,
          sttNoElexys: item.sttElexysNumber || "",
          sttTotalPiece: item.sttTotalPiece || item.totalPieces || 0,
          grossWeight: item.grossWeight || item.sttGrossWeight || 0,
          volumeWeight: item.volumeWeight || item.sttVolumeWeight || 0,
          chargeableWeight:
            item.bagCustomChargeableWeight ||
            item.bagTotalChargeableWeight ||
            0,
          productType: item.productType || item.sttProductType || "",
          commodityId: 0,
          commodityName: item.sttCommodityName || "",
          commodityCode: item.commodityGroupCode || item.sttCommodityName || "",
          commodityGroupCode: item.commodityGroupCode || "",
          commodityGroupName: item.commodityGroupName || "",
          commodityGroupIsDg: !!item.commodityGroupIsDg,
          destinationCityCode:
            item.destination || item.destinationCityCode || "",
          destinationCityName: item.destinationCityName || "",
          destinationDistrictCode: "",
          destinationDistrictName: "",
          shcCode: item.shcCode || "",
          shcDescription: item.shcName || "",
          sttPieces: item.sttPieces || [],
          isDangerousGoods: !!item.isDangerousGoods,
          bagData: item.bagData,
          sttChargeableWeight: item.chargeableWeight || 0,
          bagPhotoProof: item.bagPhotoProof || [],
          baggingNumber: item.baggingNumber || "",
          baggingVendorNumber: item.baggingVendorNumber || "",
          baggingVendorNo: item.baggingVendorNo || "",
          isDisputeBagging: !!item.isDisputeBagging,
          isQuarantine: !!item.isQuarantine
        });
      });
      CargoV2Controller.onGenerateGroupDataTable(mapped as any);
    }

    if (!this.detailData.isNewForm) {
      router.push(`/cargo/${encodeURIComponent(this.detailData.cargoNumber)}`);
    }
  }

  async fetchDetailCargo() {
    try {
      MainAppController.showLoading();
      await CargoV2Controller.fetchDetail(this.$route.query.id as any);
      this._syncFormBagOrSttFromDetail();
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          this.$t("cargo.v2.detail.error.fetchDetail"),
          () => this.fetchDetailCargo()
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async fetchDetailRtcCargo() {
    await CargoController.getDetailRetryCargo({
      cargoNo: this.rcNo,
      isPrint: false,
      version: "v3"
    });
    this._syncFormBagOrSttFromDetail();
  }

  fetchDetailData() {
    if (this.$route?.query?.rc_no) {
      this.fetchDetailRtcCargo();
    } else {
      this.fetchDetailCargo();
    }
  }

  get isIncomingOutgoing() {
    return this.$route.path?.includes("incoming-outgoing");
  }
  goBack() {
    if (this.isIncomingOutgoing) {
      router.push(`/incoming-outgoing`);
      return;
    }
    router.push(`/cargo-v2`);
  }

  goToEdit(): void {
    const no = this.$route.params.id;
    const id = this.$route.query.id;
    router.push(`/cargo-v2/${no}/edit?id=${id}`);
  }

  isTabActive(name: string) {
    const selected = this.$route.meta?.tab || this.$route.name;
    return name === selected;
  }

  tabSelected: any = {};
  changeTabs(value: any) {
    this.tabSelected = value;

    if (this.isIncomingOutgoing) {
      const no = this.$route.params.id;
      const id = this.$route.query.id;
      this.$router.push(`/incoming-outgoing/cargo-v2/${no}/${value.name}?id=${id}`);
    } else {
      const id = this.$route.query.id;
      this.$router.push({
        name: value.name,
        query: { id: id }
      });
    }

    if (value.name === "history") {
      this.fetchDetailData();
    }
  }

  openPrintPopover(event: Event): void {
    const op = this.$refs.printLabel as { toggle?: (e: Event) => void };
    op?.toggle?.(event);
  }

  errorDownloadEpl = false;
  async downloadEPL(id: number) {
    await CargoController.getDownloadData({
      id: id,
      type: "epl",
      version: "v3"
    }).then(this.fetchDetailData);
  }

  async downloadManifest(
    id: number,
    cargoNumber: string,
    destinationCityCode: string
  ) {
    const filename = `Manifest cargo ${cargoNumber} - ${destinationCityCode}`
    CargoV2Controller.getDownloadData({ id: id, type: "cargo", filename });
  }

  async printAWBLionCargo(id: number) {
    if (this.detailData.isNewForm) {
      await CargoV2Controller.downloadAwbReceipt(new DownloadAWBRequest({ id: id, awbNumber: this.detailData.cargoNumber })).then(() => {
        if (this.permissionDownloadAwbReceiptSync && this.detailData instanceof CargoV2Data) {
          this.detailData.isPrintAwb = true;
        }
        this.fetchDetailData()
      });
      return;
    }

    NGenController.printAWBLionCargo({
      AWBNo: this.detailData.cargoNumber
    }).then(this.fetchDetailData);
  }

  onSuccessPrintAwb(cargoNo: string): void {
    if (cargoNo === this.detailData.cargoNumber) {
      CargoV2Controller.cargoDetailData.isPrintAwb = true;
    }
  }

  // Print
  check = null;
  refs: any = "";
  cargoNumber = "";

  async printManifest(item: CargoData) {
    this.refs.print.printData(item.id, "manifest");
    this.cargoNumber = item.cargoNumber;
  }

  async onPrintLabel(item: CargoData) {
    this.refs.print.printData(item.id, "label");
    this.cargoNumber = item.cargoNumber;
  }

  printPti(item: CargoData) {
    this.refs.print.printPtiPdf(item.id, null, this.fetchDetailData);
    this.cargoNumber = item.cargoNumber;
  }

  printSptjNonElectronic(item: CargoData) {
    this.refs.print.printSptjNonElectronic(
      item.id,
      null,
      this.fetchDetailData
    );
    this.cargoNumber = item.cargoNumber;
  }

  printSPTJElektronik(item: CargoData) {
    this.refs.print.printSPTJElektronik(
      item.id,
      null,
      this.fetchDetailData
    );
    this.cargoNumber = item.cargoNumber;
  }

  get actionGroupOptions() {
    const item: any = this.detailData;

    const label = {
      icon: "invoice",
      label: this.$t("cargo.v2.detail.print.label"),
      clickFunction: () => {
        this.refs.print.printData(
          item.id,
          "label",
          "",
          null,
          this.fetchDetailData
        );
        this.cargoNumber = item.cargoNumber;
      }
    };
    const awb = {
      icon: "printer",
      label: "AWB Lion Cargo",
      clickFunction: () => {
        this.printAWBLionCargo(item.id);
      }
    };
    const manifest = {
      icon: "printer",
      label: this.$t("cargo.v2.detail.print.manifest"),
      clickFunction: () => {
        this.refs.print.printManifestV2(
          item.id,
          null,
          this.fetchDetailData
        );
        this.cargoNumber = item.cargoNumber;
      }
    };
    const excel = {
      icon: "document-download-outline-grey",
      label: "Download Excel",
      clickFunction: () => {
        this.downloadManifest(
          item.id,
          item.cargoNumber,
          item.destinationCityCode
        );
      }
    };
    const epl = {
      icon: "download-gray",
      label: "Download EPL",
      clickFunction: () => {
        this.downloadEPL(item.id);
      }
    };
    const pti = {
      icon: "print-pti",
      label: "PTI",
      clickFunction: () => this.printPti(item)
    };
    const sptjElectronic = {
      icon: "print-sptj",
      label: "SPTJ",
      clickFunction: () => this.printSPTJElektronik(item)
    };
    const sptjNonElectronic = {
      icon: "print-sptj",
      label: "SPTJ",
      clickFunction: () => this.printSptjNonElectronic(item)
    };

    const isPlane = item.cargoType === "plane";
    const isBTH =
      item.originCityCode === "BTH" || item.destinationCityCode === "BTH";

    if (!isPlane) {
      return [label, manifest, excel];
    }

    if (isPlane && isBTH) {
      return [label, awb, epl, manifest, excel];
    }

    const options: any[] = [label, awb];

    if (FlagsPermissionCargo.permission_cargo_print_pti_pdf.isEnabled()) {
      options.push(pti);
    }

    if (
      FlagsPermissionCargo.permission_cargo_print_electronic_sptj_pdf.isEnabled() &&
      item.cargoCommodityGroupIsElectronicDg
    ) {
      options.push(sptjElectronic);
    }

    if (
      FlagsPermissionCargo.permission_cargo_print_sptj_pdf.isEnabled() &&
      item.cargoCommodityGroupIsDg &&
      !item.cargoCommodityGroupIsElectronicDg
    ) {
      options.push(sptjNonElectronic);
    }

    options.push(manifest);
    options.push(excel);

    return options;
  }

  showModalDelete = false;
  openModalDelete(item: CargoV2Data): void {
    this.selectedItem = item;
    CargoV2Controller.setCargoIdToDelete(item.id);
    CargoV2Controller.setCargoNoForModal(item.cargoNumber);
    this.showModalDelete = true;
  }

  closeModalDelete(): void {
    this.showModalDelete = false;
    this.selectedItem = null;
    CargoV2Controller.setCargoIdToDelete(null);
  }

  async confirmDelete(): Promise<void> {
    await CargoV2Controller.deleteBooking();
    this.closeModalDelete();
  }

  get deleteModalMessage(): string {
    const no = this.selectedItem
      ? this.displayBookingNo(this.selectedItem)
      : "";
    return this.$t("cargo.messages.deleteBookingMessage", {
      bookingNumber: no
    });
  }

  displayBookingNo(item: CargoV2Data): string {
    const no = item.cargoNumber || item.bookingRequestId || "";
    return ellipsisString(no, 40) || "-";
  }

  get rebookModalMessage(): string {
    const no = this.selectedItem
      ? this.displayBookingNo(this.selectedItem)
      : "";
    return this.$t("cargo.messages.rebookBookingMessage", {
      bookingNumber: no
    });
  }

  showModalReBooking = false;
  openModalReBooking(item: CargoV2Data): void {
    this.selectedItem = item;
    this.showModalReBooking = true;
  }

  closeModalReBooking(): void {
    this.showModalReBooking = false;
    this.selectedItem = null;
  }

  goToReBooking(): void {
    const id = this.$route?.query?.rc_no;
    if (id)
      router.push({
        path: `/cargo-v2/${id}/rebooking`,
        query: { rcNo: id, cargoNo: this.cargoNo }
      });
    this.closeModalReBooking();
  }
}
